(function () {
  'use strict';

  var promoBar = document.getElementById('kitaboo-promo-bar');
  if (!promoBar) return;

  var collapseThreshold = 8;

  function onScroll() {
    if (window.scrollY > collapseThreshold) {
      promoBar.classList.add('is-collapsed');
    } else {
      promoBar.classList.remove('is-collapsed');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
